export default __webpack_public_path__ + "static/media/64.7cd310bb.jpeg";